import Swal from "sweetalert2";

export const alert = (title, text, icon) => {
    Swal.fire({
        title,
        text,
        icon,
        confirmButtonColor: "#154063",
        confirmButtonText: "OK",
    });
}